module.exports = {
    //通用
    sys_name: 'EduConnect CMS system',
    sys_code: '© Copyright EduConnect',

    // init start
    zh_cname: 'Name in Simplified Chinese',
    tw_cname: 'Name in Traditional Chinese',
    en_cname: 'Name in English',
    user_zh_cname: 'Name in Simplified Chinese',
    user_tw_cname: 'Name in Traditional Chinese',
    user_en_cname: 'Name in English',
    home: {
        school: 'School',
        add_school_user: 'Add School Account',
        teacher: 'Teacher',
        add_teacherl_user: 'Add Teacher Account',
        school_new_apply: 'New Application(s) for School',
        check: 'Check',
        teacher_new_apply: 'New Application(s) for Teacher',
        school_count: 'Number of School(s)',
        teacher_count: 'Number of Teacher(s)',
        faculty_count: 'Number of School Staff(s)',
        job_count: 'Number of Job Post(s)',
    },
    page_title: {
        mail_template: "Email Template",
        Sending_mail_records: "Sent Emails Record(s)",
        Sending_mail_info: "Detail of sent email(s)",
        School_Application_Records: "School Application Record(s)",
        School_profile: "School Edit Record(s)",
        School_Join_Us: "Job Post Record(s)",
        School_member_expire: "Member Overdue within 14 days",
        teacher_member_expire: "Member Overdue within 7 days",
        teacher_Application_Records: "Teacher Application Record(s)",
        teacher_profile: "Teacher Edit Record(s)",
        faculty_member_expire: "Member Overdue within 7 days",
        faculty_Application_Records: "SchoolStaff Application Record(s)",
        faculty_profile: "SchoolStaff Edit Record(s)",
        Information_platform: "Platform information classification",
        Basic_Website_Information: "Website basic information",
        Site_footer_Settings: "Website footer setting",
        footer_Setting_tow: "Secondary footer contents setting",
        platform_role: "CMS Role Management",
        home_ad_place: "Homepage Advertisment Management",
        history_ad_place: "History page Advertisment Management",
        ad_place: "Advertisment Management",
        ad_placeInfo: "AD Detail Management",
        tags: "Tag Category Mangement",
        tags_item: "Tag Detail Management",
        newsUpdate: "Website Notification Management",
        renewal: "Account Renew Plan Management",
        blog: "Website 教評心事 Manage",
        blog_ad: "教評心事 Ad Manage",
        cent_list: "Member Point History",
        wellness_ad: "Wellness Ad Manage",
        travel_ad: "Travel Ad Manage",
        wellness: "Website Wellness & Wealth Manage",
        travel: "Website Travel Manage",
        white: "School Whitelist Manage",
        wealth_ad: "Wealth Ad Manage",
        tech: "Editor's Pick Manage",
        tech_ad: "Editor's Pick Ad Manage",
    },
    school_record: {
        id: 'School ID',
        name: 'School Name',
        email: 'Email',
        renewal_time: 'Renew Date',
        status: 'Status',
    },
    faculty: {
        id: "SchoolStaff ID",
        name: 'SchoolStaff Name',
        desc: 'SchoolStaff Description',
        avartar: 'SchoolStaff Icon',
        change_profile: 'SchoolStaff Update Profile',
        join_time: 'SchoolStaff Join Date',
        base_info: 'SchoolStaff Basic Information',
    },
    school: {
        recruit_title: 'Job Title',
        join_time: 'School Join Date',
        base_info: 'School Basic Information',
        cn_name: 'School Name in Simplified Chinese',
        tw_name: 'School Name in Traditianal Chinese',
        en_name: 'School Name in English',
        login_account: 'Login Account for School',
        desc: 'School Description',
        address: 'School Address',
        image: 'School Photo(s)',
        news: 'School Latest News',
        recruit: 'School Posted Job(s)',
        work_number: 'Work Number',
        recruit_type: 'Recruitment Type',
        tag: 'Tag',
        job_title: 'Job Title',
        job_desc: 'Job Description',
        require: 'Job Requirement',
        entry_date: 'onBoard Date',
        work_period: 'Working Period',
        salary_range: 'Salary Range',
        salary_range2: 'Salary',
        post_date: 'Post Date',
        expiry_date: 'Expiry Date',
        change_profile: 'Update School Profile',
        last_modified: 'Category',
        change_content: 'Update Content',
        published_work: 'School Published Job(s)',
    },
    teacher_record: {
        id: 'Teacher ID',
        name: 'Teacher Name',
        alias: "Teacher Alias",
        phone: "Mobile Number",
        email: 'Email',
        renewal_time: 'Renew Date',
        status: 'Status',
        last_changed_time: 'Lastest Update',
        change_profile: 'Teacher Update Profile',
        join_time: 'Teacher Join Date',
        base_info: 'Teacher Basic Information',
        educational: "Education Experience",
        workExperience: "Working Experience",
        otherInfo: "Other",
        year: "Years",
        subject: "Major",
        desc: 'Teacher Description',
        avartar: 'Teacher Icon',
    },
    cms_email: {
        id: "Email ID",
        title: "Email Title",
        name: "Email Name",
        addTime: "Create Time",
        content: "Content",
        send_user: "Receiver Email",
        int_title: "Please Enter Email Title",
        int_name: "Please Enter Email Name",
        int_content: "Please Enter Email Content",
        mail_end: 'Footer',
        mail_dear: 'HEader',
        org_cname: 'Sender',
    },
    infoPush: {
        name: "Website Notification Name",
        content: "Notfication Content",
        cname_input: 'Please Enter Notification Name',
        content_input: 'Please Enter Notification Content',
    },
    job: {
        id: "JobPost ID",
        type: "JobPost Type",
        name: "JobPost Title",
    },
    table: {
        search: 'Search',
        reset: 'Reset',
    },
    Langue: {
        zn: 'Simplified Chinese',
        tw: 'Traditional Chinese',
        en: 'English',
    },
    Info: {
        condition: "Terms and Conditions",
        contactUs: "About Us",
        footer_title: "Footer Title",
        order: 'Display Order',
        code: 'Index',
        two_title: "Secodary Title",
        title: "Footer Title",
        url: "Direct URL",
        contentInput: 'Please Enter Terms and Conditions',
        copyrightInput: 'Please Enter Copywriting',
        copyright: "Copywriting",
        user_agreement: "User Agreement",
        privacy_policy: "Privacy Policy",
        terms_us: "Terms and Use",
        homepage: "WEB URL",
        homepageInput: 'Please enter the website home page',
        homeContactUs: "Contact Us (Home page)",
        contactUsInput: 'Please enter contact us content',
        description: 'Meta Description',
        keywords: 'Meta keywords',
        keywords_hint: 'keywords should be separated by English ","',
    },
    Role: {
        name: "CMS Role Name",
        cname_input: 'Please Enter Role Name',
    },
    Ad: {
        name: "Advertisment Name",
        name_home: "Advertisment in Homepage",
        name_history: "Advertisment in History Page",
        name_info: "Details of Advertisment",
        cname_input: 'Please Enter Advertisment Name',
        url_link_input: 'Please Enter Direct URL',
        beginDate_input: 'Please Enter Post Date',
        endDate_input: 'Please Enter Expiry Date',
        name_info_input: 'Please Enter Advertisment Detail',
        name_home_input: 'Please Enter Homepage Advertisment Name',
        name_history_input: 'Please Enter History Page Advertisment Name',
        code_input: 'Please Enter Code',
        beginDate: 'Post Date',
        endDate: 'Expiry Date',
    },
    Tags: {
        name: "Tag Name",
        // names: "Secendary Tag Name",
        names: "Tag Name",
        wi: "Weights"
    },
    renewal: {
        name: "Renew Plan Name",
        cname_input: "Please Enter Plan Name",
        price_input: 'Please Enter Price',
        days_input: 'Please Enter Days',
    },
    contact_name: 'Contact Person',
    contact_mobile: 'Contact Mobile',
    detail: 'Details',
    reviewing: 'Under Review',
    reviewed: 'Reviewed',
    review_overdue: 'Overdue',
    trans_history_record: 'Transaction History',
    pwd_admin: 'Password Mangement',
    release_status: 'Status',
    look_count: 'Viewed',
    deliver_count: 'Number of Applied',
    last_update_time: 'Latest Update',
    force_off_shelf: 'Force Disable',
    release: 'Opening',
    unRelease: 'Draft',
    vip_payment_plan: 'Member Renew Plan Name',
    vip_due_time: 'Member Next Renew Date',
    off_shelf: 'Disable',
    confirm_off_shelf: 'Confirm to disable?',
    apply_agree: 'Pass Application',
    confirm_apply_agree: 'Confirm to Agree?',
    apply_reject: 'Reject Application',
    confirm_apply_reject: 'Confirm to Reject?',
    topic: 'Topic',
    modify: 'Modify',
    edit: 'Edit',
    revert: 'Revert',
    force_revert: 'Force Revert',
    confirm_revert: 'Confirm to Revert?',
    text_check_res: 'Keywords Scanning Result',
    new_update: 'Latest Update',
    abnormal: 'Abnormal',
    not_abnormal: 'Normal',
    approval_refused: 'Rejcted',
    activate: 'Active',
    nonactivated: 'inActivee',
    no_server_rw_remark: 'Must have the reject reason',
    back: 'Back',
    salary: 'Salary',
    company: 'Company',
    upload_file_name: 'Upload File Name',
    click_view: 'Click to View',
    payment: 'Payment Method',
    publisher: 'Publisher',
    sure: 'Confirm',
    improve_information: 'Please Complete！',
    website_logo: "Logo",
    content: "Content",
    hotline: "Hotine",
    fax: "Fax",
    sort_input: "Please Enter Order Number",
    score_input: "Please Enter Weight",
    addressInput: 'Please Enter Address',
    emailInput: 'Please Enter Email',
    faxInput: 'Please Enter Fax',
    hotlineInput: 'Please Enter Hotline',
    userAgreementInput: 'Please Enter User Agreement',
    privatePrivacy: 'Please Enter Privacy Policy',
    termsUse: 'Please Enter Terms of Use',
    enabled: 'Enabled',
    amount: 'Total Amount',
    ID: "Account",
    PWD: "Password",
    btn_submit: 'login',
    pwd_login: 'Log in Ed CMS',
    reset_pwd: 'Reset Password',
    input_code: "Please Enter Account",
    input_pwd: "Please Enter Password",

    img_lnk: "Image",
    add_sub: 'Add Secondary',
    info: 'Details',
    cname: 'Name in Simplified Chinese',
    code: 'Code',
    web_url: "URL Link",
    sort: 'Order',
    icon: "Icon",
    icon_color: "Icon Colr",
    system_group: 'System Group',
    cat_id: 'Category',
    cdesc: 'Description',
    cname_tw: 'Name in Traditional Chinese',
    cdesc_tw: 'Description in Traditional Chinese',
    cname_en: 'Name in English',
    cdesc_en: 'Description in English',
    input: 'Please Enter',
    select: 'Please Select',
    root: "Root",
    upd: 'Update',
    x_dd: " =",
    x_yd: " ≈",
    x_xy: " <",
    x_mh: "：",
    x_fh: "；",
    op_ok: 'Success',
    op_err: 'Error, please try again.',

    ex_type: 'Extension Type',
    system_use: 'System can Use',
    org0_use: 'Master can Use',
    org1_use: 'Direct can Use',
    org2_use: 'Shop can Use',
    insert_user: 'Add User',
    add_user: 'Create Account',
    add_time: 'Join Date',
    upd_user: 'Edit User',
    upd_time: 'Update Time',
    mod_title: 'Function Module',
    add: 'Add',
    org_level: "Organization Level",
    mod_cname: "Module Name",
    mod_cdesc: "Module Description",
    all: 'All',
    set_role: 'Role Setup',
    op: 'Control',
    search_content: 'Search',
    prev: 'Previous',
    next: 'Next',
    one_page: 'One Page',
    one_page_line: 'Line',
    add_role: 'Add Role',
    select_func: "Please Select Function",
    search_nodata: 'No Related Data',
    incomplete: 'Please complete',
    clean_cache: "Clean Cache",
    clean_label: "Clean",
    cache_manage: "Cache Mange",
    clean_com_setup: "Clean Cache Setup",
    email: "Email",
    zhiwei: 'Position',
    isJump: "Need Direct",
    external_link: "Direct to 3rd party",
    Whether_by: "Whether by",
    title: "Title",
    brief: "intro",
    isHome: "Show int",
    content_input: "Please enter the content",
    title_input: "Please enter title",
    brief_input: "Please enter introduction",
    preserve: "Save",
    system_layout: "System Layout",
    time_fr: 'Start time',
    time_to: 'End time',
    order_code: 'Order Number',
    Integral_set: "Point Settings",
    Welcome_reward: "Welcome Award",
    Credit_time: "Point expire after N days, if N is the integer multiple of 365, expiry unit is Year",
    Integral_transform: "N points = 1 HKD",
    PointInt: "Spent 1 HKD will gain N point(s)",
    PresentExp: "Gift Points",
    time_fr_input: 'Please enter the start time',
    time_to_input: 'Please enter the ending time',
    PresentExp_input: 'Please enter the amount for gift points',
    effective_time_input: 'Please enter expiry date for gift points',
    equivalent_value_input: 'Please enter the point amount for Point to Cash calculation',
    Integral_transform_input: 'Please enter the point amount gained when spent 1 HKD in ecom',
    cent: {
        time: "Transaction Datetime",
        expire_time: "Expiry Date",
        integral: "Points",
        employ: "Add / Deduct",
        name: "教評心事 Ad Name",
        name_input: "Please enter the Advertisement name in 教評心事",
        cent_expire_time: "Credit Expiration Date",
    },
    wellness: {
        name: "wellness Ad Name​",
        name_input: "Please enter the Advertisement name in wellness page",
    },
    wealth: {
        name: "wealth Ad Name​",
        name_input: "Please enter the Advertisement name in wealth page",
    },
    travel: {
        name: "Travel Ad Name​",
        name_input: "Please enter the Advertisement name in Travel page",
    },
    alumni: 'Alumni',
    parent: 'Parent',
    student: 'Student',
    Details_pictures: 'Pic for Detail',
    p_upload_img: 'Please upload pictures',
    photo_tip: 'Recommended upload image size is',
    and: 'and',
    shop_welcome_set: 'New Memeber Bonus',
    amount_bonus: 'Reward Amount',
    member_day: 'After registration within N days treat as new Member',
    Reward_ratio: 'Reward multiplier',
    amount_bonus_input: 'Please enter Reward multiplier',
    member_day_input: 'Please enter Reward amount',
    Reward_ratio_input: 'Please enter the days for new Member duration',
    Reward_Type: 'Reward Type',
    onTop: 'On Top',
    product_ids: 'product IDS',
    wellness_ids: 'Associated health',
    product_ids_input: 'Please enter the associated product IDS',
    wellness_ids_input: 'Please enter the associated health Id',
    travel_ids: 'Associated Travel',
    travel_ids_input: 'Please enter the associated travel Id',
    noMore: 'No more',
    email_error: "Incorrect email format",
    WinmailTitle: 'System Email Setting',
    mail_code: 'Email Type',
    mail_user_name: 'Email Account',
    mail_password: 'Email Passcode',
    mail_per_day: 'Send Amount per Day',
    mail_per_hour: 'Send Amount per Hour',
    mail_per_minute: 'Send Amount per Min',
    default_status: 'Default',
    mail_code_input: 'Please choose email type',
    mail_user_name_input: 'Please enter email account',
    mail_password_input: 'Please enter email password',
    mail_per_day_input: 'Please enter send amount per day',
    mail_per_hour_input: 'Please enter send amount per hour',
    mail_per_minute_input: 'Please enter send amount per minute',
    multiples: 'Multiple',
    concept: 'agree with our mission',
    author: 'Author',
    author_input: 'Please enter author',
    thinkTitle: 'Manage 冷思熱話',
    think_ids: 'Link to 冷思熱话',
    think_ids_input: ' Please enter Link to 冷思熱话Id',
    video_input: 'Please enter YouTube video URL',
    videoURL: 'Video URL',
    Teaching_Staff: 'Teaching Staff',
    Non_Teaching_Staff: 'Non-Teaching Staff',
    static: "static",
    rotation: "otation",
    detailed_page: "detailed page",
    Copy_language: "Copy to other languages",
    NotSuitable: "Not suitable",
    SalaryType: "Salary Type",
    name: 'Name',
    RecordData: "Data submission record",
    type_input: 'Please choose type',
    techCentName: "Editor's Pick Ad Name",
    techName_input: "Please enter the Editor's Pick Ad Name",
};



// WEBPACK FOOTER //
// ./src/utils/lang/en.js